export enum EWebclientSnippet {
  SIMPLE,
  ADVANCED,
}
